import { useEffect, useState } from 'react';

interface UseCountdownOptions {
  enabled: boolean;
  initialCountdown: number;
  intervalMs?: number;
  loop?: boolean;
  onComplete?: () => void;
}

export const useCountdown = ({
  enabled,
  initialCountdown,
  intervalMs = 1000,
  loop = false,
  onComplete,
}: UseCountdownOptions) => {
  const [countdown, setCountdown] = useState(initialCountdown);

  // Reset the visible countdown whenever a new countdown cycle is enabled.
  useEffect(() => {
    setCountdown(initialCountdown);
  }, [enabled, initialCountdown]);

  // Tick only while enabled so consumers can keep the hook mounted without leaking timers.
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      if (countdown <= 1) {
        if (loop) {
          setCountdown(initialCountdown);
          return;
        }

        onComplete?.();
        return;
      }

      setCountdown(previousCountdown => previousCountdown - 1);
    }, intervalMs);

    return () => window.clearTimeout(timeoutId);
  }, [countdown, enabled, initialCountdown, intervalMs, loop, onComplete]);

  return countdown;
};
